import { Component, OnInit } from '@angular/core';

import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Pageable } from '../shared/model/pageable.model';
import { UsuarioService } from './usuario.service';
import { Usuario } from '../shared/model/usuario.model';
import { PrestadorService } from '../prestador/prestador.service';
import { Prestador } from '../shared/model/prestador.model';
import { ToastrService } from 'ngx-toastr';

@Component({templateUrl: './usuario.component.html', styleUrls: ['./usuario.component.css']})
export class UsuarioComponent implements OnInit {

  usuario: Usuario;
  listaUsuarios: Usuario[];
  listaPrestadores: Prestador[];
  perfis = [];
  disabledPrestador = true;

  valueFilter = '';

  pageable: Pageable;
  labels: any = { previousLabel: '', nextLabel: '' };

  constructor(config: NgbModalConfig, private modalService: NgbModal, private usuarioService: UsuarioService,
      private toast: ToastrService, private prestadorService: PrestadorService) {
       // customizar os valores default do modal.
        config.backdrop = 'static';
        config.keyboard = false;
   }

  ngOnInit() {
    // Inicializando o pageable com valores padrões.
    this.pageable = new Pageable();
    this.buildPerfisUsuario();
    this.getPrestadores();
    this.getUsuarios();
  }

  // Método responsável pelo evento de paginação da table.
  pageChanged(event) {
    this.pageable.page = event;
    this.getUsuarios();
  }

  // Método responsável pelo filtro da table.
  buscarUsuarios() {
    this.pageable.page = 1;
    this.getUsuarios();
  }

  // Método responsável por buscar a lista de usuários.
  private getUsuarios() {
    this.usuarioService.listarUsuarios(this.pageable, this.valueFilter).subscribe(
      (dados) =>  {
        this.pageable.totalElements = dados.totalElements;
        this.listaUsuarios = dados.content;
      },
      errorResponse => this.toast.error(errorResponse.error.mensagemUsuario)
    );
  }

 // Método responsável por buscar a lista de prestadores.
 private getPrestadores() {
    this.prestadorService.listarTodosPrestadores().subscribe(
      (dados) => this.listaPrestadores = dados,
      errorResponse => this.toast.error(errorResponse.error.mensagemUsuario)
    );
  }

  /**
   * Método para validar se usuário será do tipo prestador.
   * Usuário com perfil 1 é do tipo prestador.
   * @param perfilId identificador do perfil
   */
  changePerfil(perfilId: any): void {
    if (perfilId !== 1 && perfilId !== 4) {
      this.disabledPrestador = true;
      this.usuario.prestador = null;
    } else {
      this.disabledPrestador = false;
    }
  }

  // Método responsável por preparar o modal para cadastrar um novo usuário
  novoUsuario(content) {
      // Inicializar o objeto toda vez que o modal for chamado
      this.usuario = new Usuario();

      this.modalService.open(content, { size: 'lg' });
  }

  // Método responsável para preparar o modal para alteração
  alterarUsuario(content, usuarioId: number) {
    this.usuarioService.buscar(usuarioId).subscribe(
        (usuario) => {
          // Atribuir ao objeto usuário os dados retornados da API
          this.usuario = usuario;

          // TODO: Validar outra forma de setar o objeto perfil e prestador para o select.
          this.usuario.perfil = usuario.perfil.id;

          if (usuario.prestador !== null) {
            this.usuario.prestador = usuario.prestador.id;
            this.disabledPrestador = false;
          }

          this.modalService.open(content, { size: 'lg' });
        },
        (errror) => this.toast.error('Erro ao carregar usuario, tente novamente!')
    );
  }

  // Método usado para cadastrar/alterar um usuário
  save(form) {
    if (this.usuario.id) {
        this.usuarioService.alterar(this.usuario).subscribe(
          () => {
            this.toast.success('Usuário alterado com sucesso!');
            this.getUsuarios();
          },
          (responseError) => this.toast.error('Erro ao alterar o usuário, tente novamente!'))
        ;
    } else {
      this.usuarioService.cadastrar(this.usuario).subscribe(
        () => {
          this.toast.success('Usuario cadastrado com sucesso!');

          this.pageable.page = 1;
          this.getUsuarios();

          // Resetar o form após confirmar
          form.reset();

          // Inicializar o objeto toda vez que for alterado.
          this.usuario = new Usuario();
        },
        (responseError) => this.toast.error('Erro ao cadastrar o usuario, tente novamente!')
      );
    }
  }

  inativarUsuario(usuarioId: number) {
    this.usuarioService.inativar(usuarioId).subscribe(
      () => {
        this.toast.success('Usuário inativado com sucesso!');
        this.getUsuarios();
      },
      (responseError) => this.toast.error('Erro ao inativar usuário, tente novamente!')
    );
  }

  ativarUsuario(usuarioId: number) {
    this.usuarioService.ativar(usuarioId).subscribe(
      () => {
        this.toast.success('Usuário ativado com sucesso!');
        this.getUsuarios();
      },
      (responseError) => this.toast.error('Erro ao ativar usuário, tente novamente!')
    );
  }

   /**
   * Método para listar os perfis de acesso dos usuários.
   */
  private buildPerfisUsuario() {
    this.perfis.push({id: 1, nome: 'Prestador' }, {id: 2, nome: 'DTISS' }, {id: 3, nome: 'GPM' }, {id: 4, nome: 'Prestador Gestor' });
  }
}
